export const getServingGramWeight = (servingUnit) => {
  const value = String(servingUnit || "").trim();

  const parentheticalMatch = value.match(/\(([^)]+)\)/);
  if (parentheticalMatch) {
    const parsed = Number.parseFloat(parentheticalMatch[1]);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }

  const gramMatch = value.match(/(\d+(?:\.\d+)?)\s*(?:g|gram|grams)\b/i);
  if (gramMatch) {
    const parsed = Number.parseFloat(gramMatch[1]);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }

  const firstNumberMatch = value.match(/(\d+(?:\.\d+)?)/);
  if (firstNumberMatch) {
    const parsed = Number.parseFloat(firstNumberMatch[1]);
    if (Number.isFinite(parsed) && parsed > 0) return parsed;
  }

  return 100;
};

export const getIngredientGramQuantity = (ingredient = {}) => {
  const qty = Number.parseFloat(ingredient.qty) || 0;
  return getServingGramWeight(ingredient.serving_unit) * qty;
};
